import styled from 'styled-components';

export const CustomTableStyled = styled.div`
  table,
  th,
  td {
    border: 1px solid rgb(222, 222, 222);
    border-collapse: collapse;
    padding: 8px;
  }
`;
